import { ASSETS } from '@/constants/assets';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function CTA() {
  return (
    <section className="relative py-24 md:py-28 bg-secondary-950 overflow-hidden">

      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={ASSETS.cta.background}
          alt="Bomba hidráulica premium em bancada técnica — Engenharia DURAFLOW"
          className="w-full h-full object-cover object-center"
        />
        <div
          className="absolute inset-0 bg-secondary-950/78"
          aria-hidden="true"
        ></div>
        <div
          className="absolute inset-0 bg-gradient-to-t from-secondary-950/50 via-transparent to-secondary-950/40"
          aria-hidden="true"
        ></div>
      </div>

      {/* Accent lines */}
      <div
        className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500/25 to-transparent"
        aria-hidden="true"
      ></div>
      <div
        className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500/15 to-transparent"
        aria-hidden="true"
      ></div>

      {/* Warm spot glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-primary-500/3 blur-[150px] pointer-events-none"
        aria-hidden="true"
      ></div>

      {/* Content */}
      <div className="relative z-10 max-w-container mx-auto px-4 md:px-6 text-center">
        <ScrollReveal>
          <span className="inline-block text-xs md:text-sm font-semibold tracking-[0.22em] uppercase text-primary-400 mb-5">
            Disponibilidade operacional
          </span>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-background-50 font-heading leading-tight max-w-3xl mx-auto">
            Sua operação não pode parar.
          </h2>

          <p className="mt-5 text-base md:text-lg text-foreground-200/80 max-w-2xl mx-auto leading-relaxed">
            Nossa equipe avalia tecnicamente cada componente e recomenda a solução mais adequada para sua operação: recuperação especializada ou fornecimento de componentes hidráulicos novos.
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}